import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import HeroImg from '../../assets/homePageHero.svg';
import { Header } from "./Comps/Header";
import InputBox from "./Comps/InputBox";
import InputBoxLabel from "./Comps/InputBoxLabel";
import ScreenTitle from "./Comps/ScreenTitle";
import InputCheckBox3 from "./checkbox3";
import { env, hideWaitingModal, showErrorOnUI, showWaitingModal } from "../../environment/environment";
import { consentlogapiuserId } from "../Arthmate/Modules/AutoRepayment/autopaycreator";

export default function FibeMobileNumberVerification() {
  const [number, setNumber] = useState(localStorage.getItem('phoneNumber') || '');
  const [accepted, setAccepted] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();
  const CHECKBOX_ID = "inputCheckBoxFinal";

  async function handleNavigation() {
    if (!accepted) {
      showErrorOnUI(document.getElementById(CHECKBOX_ID), false);
      return;
    }
    showWaitingModal();
    try {
      const response = await axios.post(
        `${env.api_Url}userDetails/sendOtpToMobile?mobile=${number}`
      );
      if (response.data.message === "success") {
        localStorage.setItem("phoneNumber", number);
        navigate('/patient/fibeOtpAuthentication');
      }
    } catch (error) {
      showErrorOnUI(null, true);
    } finally {
      hideWaitingModal();
    }
  }
  const handleconcent=()=>{
    setAccepted(!accepted)
    // consentlogapiuserId(localStorage.getItem('userId'),'conscenttype','timeStamp',callback=>{

    // }))
    consentlogapiuserId(localStorage.getItem('userId'),'number_verification_consent',new Date().toISOString(),callback=>{

    })

  }

  return (
    <main className="screenContainer" style={{ position: "relative" }}>
      <Header progressBar={"hidden"} />
      <ScreenTitle title="Verify your number to apply" styles={{ marginBottom: "14px" }} />
      <InputBoxLabel label="Enter number linked to your PAN or bank account" />
      <InputBox
        type="number"
        value={number}
        setValue={setNumber}
        Prefix="+91"
        styles={{ margin: "10px 0", border: "0" }}
        placeholder="Enter your mobile number"
      />
      <section
        style={{
          position: "relative",
          background: "#f6f8fb",
          borderRadius: "10px",
          padding: "10px 20px 25px 15px",
          marginTop: "18px",
          marginBottom: "8px",
          boxShadow: "0 1.5px 6px rgba(24,46,98,0.07)"
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "6px", marginLeft: '-17px' }}>
          <InputCheckBox3
            name="consentFinal"
            id={CHECKBOX_ID}
            label=""
            value={accepted}
            setValue={()=>handleconcent()}
            styles={{
              marginRight: "14px",
              marginTop: "3px",
              minWidth: "22px",
              minHeight: "22px",
            }}
          />
        </div>
        <ol style={{
          margin: 0,
          paddingLeft: "21px",
          color: "#23245b",
          fontSize: "15px",
          lineHeight: "normal",
          overflow: "hidden"
        }}>
          <li style={{ marginBottom: "10px" }}>
            I confirm this number is linked to my Aadhaar, PAN, and income account. I authorize CareCoin Technologies Pvt Ltd and its partners to fetch my credit information from CIBIL, Experian, Equifax, etc. as it will be used only for identification and assessment.
          </li>
        
                <li style={{ marginBottom: "10px" }}>
                  I also consent to the collection, storage, and use of my Aadhaar, employment, and other details needed to process my application, as per applicable laws.
                </li>
                <li style={{ marginBottom: "10px" }}>
                  I hereby authorise CareCoin Technologies Pvt Ltd and its lending partners to contact me via call/SMS/WhatsApp overriding my registry on the NDNC/NCPR to provide assistance and support with the credit application process.
                </li>
                <li>
                  I accept the <span style={{
                    color: "#514C9F",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                    onClick={() => window.open("/terms-and-conditions", "_blank")}
                  >Terms & Conditions </span> and{" "}
                  <a
                    href="https://www.carepay.money/privacyPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="termsAndCond"
                    style={{
                      textDecoration: "underline",
                      fontWeight: "600",
                      color: "#514C9F"
                    }}
                  >
                    Privacy Policy
                  </a>
                </li>
       
        </ol>
      
      </section>
      <button
        onClick={handleNavigation}
        className="submit"
        disabled={!accepted}
        style={{
          cursor: accepted ? "pointer" : "not-allowed",
          opacity: accepted ? 1 : 0.6,
        }}
      >
        Send OTP
      </button>
      <div
        style={{
          display: "flex",
          placeContent: "center",
          alignSelf: "flex-end",
          marginTop: "64px"
        }}
      >
        <img
          src={HeroImg}
          alt="Hero Illustration"
          style={{
            margin: "8px",
            borderBottom: "1px solid #eee",
            maxWidth: "260px",
            width: "100%"
          }}
        />
      </div>
    </main>
  );
}
